import { z } from 'zod';

import { ZodDateString } from '@Common/types/zod/zod-date-string';
import { endpoint, GetEndpointType } from '@Common/types/zod/zod-endpoint';
import { createZodParamsValidator } from '@Common/types/zod/zod-params';
import { ZodTrimmedString } from '@Common/types/zod/zod-trimmed-string';

export const ZodSearchCompanyQuery = createZodParamsValidator(
  z.object({
    query: ZodTrimmedString.min(3),
  }),
);

export const ZodSearchCompanyItem = z.object({
  name: ZodTrimmedString,
  legal_form: ZodTrimmedString,
  legal_category: ZodTrimmedString,
  registration_date: ZodDateString.nullable(),
  siret: ZodTrimmedString,
  siren: ZodTrimmedString,
  naf_code: ZodTrimmedString,
  street: ZodTrimmedString.nullable(),
  postal_code: ZodTrimmedString.nullable(),
  city: ZodTrimmedString.nullable(),
});

export const ZodSearchCompanyResponse = z.object({
  companies: z.array(ZodSearchCompanyItem),
});

export const getQuestionsSearchCompanyEndpoint = endpoint({
  method: 'GET',
  queryParams: ZodSearchCompanyQuery,
  responseBody: ZodSearchCompanyResponse,
});

export type GetQuestionsSearchCompanyEndpoint = GetEndpointType<
  typeof getQuestionsSearchCompanyEndpoint
>;
